// extracted by mini-css-extract-plugin
export default {"container":"OKf_o5","shrinked":"Mrsxps","icon":"G9r62X","title":"_u3qsL mz-default-dark-font","message":"c1detT mz-default-dark-font","button":"SNzF7J"};